<template>
  <div class="tenderDetails">
    <v-topBar ></v-topBar>
    <div class="setNavBg">
      <v-header :navInfo='navInfo'></v-header>
    </div>
    <v-detailsBanner></v-detailsBanner>
    <div class="detailCon">
      <div class="detailTop">
        <h3>酷怡国际旅行社（上海）有限公司（装修）项目办公家具采购及安装招标酷怡国际旅行社（上海）有限公司（装修）项目办公家具采购及安装招标</h3>
        <div class="projectLocation clearfix">
          <span class="pull-left">项目位置：</span>
          <p>全国，包括但不限于上海、北京、重庆、大连、沈阳、锦州、徐州、苏州、常德、桂林等，包括但不限于上海、北京等包括但不限于上海、北京、重庆、大连、沈阳、锦州、徐州、苏州、常德、桂林等。</p>
        </div>
        <div class="closingDate clearfix">
          <span class="pull-left">截止日期：</span>
          <p>2018-12-05</p>
        </div>
        <div class="tenderingMain clearfix">
          <span class="pull-left">招标主体：</span>
          <p>酷怡国际旅行社（上海）有限公司</p>
        </div>
        <ul class="clearfix">
          <li class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <p><span>报名联系人：</span>Lizzy CHEN（陈婉盈）</p>
          </li>
          <li class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <p><span>联系邮箱：</span>lizzy.chen@thomascook.com.cn</p>
          </li>
          <li class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <p><span>联系电话：</span>021-23300729</p>
          </li>
          <li class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <p><span>联系地址：</span>上海市黄浦区中山东二路600号外滩金融中心S1幢06-07单元</p>
          </li>
        </ul>
        <p class="tenderingBtn">
          <button type="button" class="btn btn-primary">立即报名</button><button type="button" class="btn btn-default">分享</button>
        </p>
      </div>
      <div class="detailbottom">
        <div class="proCon">
          <div class="tabTitle">
            <ul id="detailTab" class="nav nav-tabs">
              <li class="active">
                <a href="#projectDetails" data-toggle="tab">项目详情<div class="tabLine"></div></a>
              </li>
              <li>
                <a href="#enclosure" data-toggle="tab">附件<div class="tabLine"></div></a>
              </li>
              <li>
                <a href="#otherInfor" data-toggle="tab">其他信息<div class="tabLine"></div></a>
              </li>
            </ul>
          </div>
          <div class="tabCon">
            <div id="detailTabContent" class="tab-content">
              <div class="clearfix tabConBox tab-pane fade in active" id="projectDetails">
                <h4><span></span>项目概况</h4>
                <div class="tabContentBox">
                  <p>公告名称 | 酷怡国际旅行社（上海）有限公司（装修）项目办公家具采购及安装招标</p>
                  <p>项目简介 | 酷怡国际旅行社（上海）有限公司（装修）项目办公家具采购及安装招标 https://pan.baidu.com/s/1ciIZPm6ucqEYcaG7RiAeQw</p>
                  <p>项目位置 | 上海蒙自路207号12号楼</p>
                </div>
                <h4><span></span>招标范围及技术要求</h4>
                <div class="tabContentBox">
                  <p>办公家具设计、提供、安装项目</p>
                </div>
                <h4><span></span>定标原则描述</h4>
                <div class="tabContentBox">
                  <p>综合方案最优中标</p>
                </div>
                <h4><span></span>入围条件</h4>
                <div class="tabContentBox">
                  <p>营业执照，注册资金200万元以上，独立法人 办公家具加工制造企业相关资质</p>
                </div>
                <h4><span></span>报名方式</h4>
                <div class="tabContentBox">
                  <p>登录复星集团采招信息平台（http://ex.onelinkplus.com/ ，服务热线：0516-87796393），点击招标公告进行报名和投标。</p>
                </div>
                <h4><span></span>投标报名提交材料</h4>
                <div class="tabContentBox">
                  <p>1､营业执照，注册资金200万元以上，独立法人</p>
                  <p>2､办公家具加工制造企业相关资质</p>
                </div>
              </div>
              <div class="clearfix tabConBox tab-pane fade" id="enclosure">
                <h4><span></span>项目概况</h4>
                <div class="tabContentBox">
                  <p>公告名称 | 酷怡国际旅行社（上海）有限公司（装修）项目办公家具采购及安装招标</p>
                  <p>项目简介 | 酷怡国际旅行社（上海）有限公司（装修）项目办公家具采购及安装招标 https://pan.baidu.com/s/1ciIZPm6ucqEYcaG7RiAeQw</p>
                  <p>项目位置 | 上海蒙自路207号12号楼</p>
                </div>
                <h4><span></span>招标范围及技术要求</h4>
                <div class="tabContentBox">
                  <p>办公家具设计、提供、安装项目</p>
                </div>
                <h4><span></span>定标原则描述</h4>
                <div class="tabContentBox">
                  <p>综合方案最优中标</p>
                </div>
                <h4><span></span>入围条件</h4>
                <div class="tabContentBox">
                  <p>营业执照，注册资金200万元以上，独立法人 办公家具加工制造企业相关资质</p>
                </div>
                <h4><span></span>报名方式</h4>
                <div class="tabContentBox">
                  <p>登录复星集团采招信息平台（http://ep.fosun.com/ ，服务热线：0516-87796393），点击招标公告进行报名和投标。</p>
                </div>
                <h4><span></span>投标报名提交材料</h4>
                <div class="tabContentBox">
                  <p>1､营业执照，注册资金200万元以上，独立法人</p>
                  <p>2､办公家具加工制造企业相关资质</p>
                </div>
              </div>
              <div class="clearfix tabConBox tab-pane fade" id="otherInfor">
                <h4><span></span>项目概况</h4>
                <div class="tabContentBox">
                  <p>公告名称 | 酷怡国际旅行社（上海）有限公司（装修）项目办公家具采购及安装招标</p>
                  <p>项目简介 | 酷怡国际旅行社（上海）有限公司（装修）项目办公家具采购及安装招标 https://pan.baidu.com/s/1ciIZPm6ucqEYcaG7RiAeQw</p>
                  <p>项目位置 | 上海蒙自路207号12号楼</p>
                </div>
                <h4><span></span>招标范围及技术要求</h4>
                <div class="tabContentBox">
                  <p>办公家具设计、提供、安装项目</p>
                </div>
                <h4><span></span>定标原则描述</h4>
                <div class="tabContentBox">
                  <p>综合方案最优中标</p>
                </div>
                <h4><span></span>入围条件</h4>
                <div class="tabContentBox">
                  <p>营业执照，注册资金200万元以上，独立法人 办公家具加工制造企业相关资质</p>
                </div>
                <h4><span></span>报名方式</h4>
                <div class="tabContentBox">
                  <p>登录复星集团采招信息平台（http://ep.fosun.com/ ，服务热线：0516-87796393），点击招标公告进行报名和投标。</p>
                </div>
                <h4><span></span>投标报名提交材料</h4>
                <div class="tabContentBox">
                  <p>1､营业执照，注册资金200万元以上，独立法人</p>
                  <p>2､办公家具加工制造企业相关资质</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
import header from '@/components/v-header/header'
import topBar from '@/components/topBar'
import detailsBanner from '@/components/detailsBanner'
import footer from '@/components/v-footer'
import backToTop from '@/components/backToTop'
export default {
  props: [],
  data () {
    return {
      navInfo: {},
      webConfigInfo:{}
    }
  },
  components: {
    'v-header': header,
    'v-topBar': topBar,
    'v-detailsBanner': detailsBanner,
    'v-footer': footer,
    'v-backToTop': backToTop
  },
  created () {
    this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainInfo', {
      columnType: 0,
      positionType: 0
    }).then((res) => {
      this.data = res.data;
    // alert(JSON.stringify(this.data));
      this.navInfo = this.data;
//      this.bannerInfo = this.data;
      // this.data.columnInfos.forEach(column => {
      //   this.navList.push(column.columnName);
      // });
      // this.bannerList = this.data.bannerPictureDtos;
      // this.paramInfo = this.data.paramDto;
      this.webConfigInfo = this.data.webConfigInfoDto;
      // this.data.bannerPictureDtos.forEach(banner => {
      //   this.bannerList.push(banner.bannerPicturePath);
      // });
    }).catch((err) => {
        console.log(err)
    })
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tenderDetails/index.vue